export default __webpack_public_path__ + "img/8eea7850e110b3e897910f4e07649255.png";